import splide from "@splidejs/splide";
import "@splidejs/splide/css";

export const initSlideshows = () => {
	const sliders = document.querySelectorAll(".splide");

	// sliders.forEach((slider) => {
	// 	// const options = JSON.parse(slider.dataset.splide);
	// 	new splide(slider).mount();
	// });

	if (document.querySelector(".park-history-slider")) {
		new splide(".park-history-slider", {
			type: "fade",
			perPage: 1,
			perMove: 1,
			pagination: true,
			gap: "1rem",
		}).mount();
		const slider = document.querySelector(".park-history-slider");
		slider.querySelectorAll(".splide__slide").forEach((slide) => {
			// if the current slide contains the class ".splide__slide--clone" then continue to the next item
			if (slide.classList.contains("splide__slide--clone")) return;

			// get the year element
			const year = slide.querySelector(".year");

			// get the index of the slide (its in the last two digits of the id)
			const slideIndex = slide.id.slice(-2);
			// get the pagination element for this slide
			const paginationLi = [];
			const paginationButtons = document.querySelectorAll(".splide__pagination__page");
			paginationButtons.forEach((button) => {
				paginationLi.push(button.closest("li"));
			});
			// get the pagination pager for this slide
			const pager = paginationLi[slideIndex - 1];

			// create a span element with the year.innerHTML within it
			const yearSpan = document.createElement("span");
			yearSpan.classList.add("year");
			yearSpan.innerHTML = year.innerHTML;

			// append the year after the button within the pager
			pager.append(yearSpan);
		});
	}

	if (document.querySelector(".company-logo-slider")) {
		new splide(".company-logo-slider", {
			type: "loop",
			perPage: 5,
			perMove: 1,
			pagination: false,
			width: "100%",
			gap: "3rem",
			breakpoints: {
				992: {
					perPage: 3,
				},
				576: {
					perPage: 1,
				},
			},
		}).mount();
	}
};
